/**
 * Clash Games Constants
 */

// Game settings
export const GAME_TITLE = "Clash Connections";
export const MAX_MISTAKES = 4;
export const CATEGORY_SIZE = 4;
export const NUM_CATEGORIES = 4;

// App info
export const APP_NAME = "Clash Connections";
export const APP_TAGLINE = "Create four groups of four!";
export const APP_VERSION = "2.0";

// Brand assets - paths relative to public folder
export const ASSETS = {
  // Main Clash logo
  clashLogo: "/CLASH Logo.png",

  // Connections icon
  connectionsIcon: "/Connections Icon.png",

  // OCC brand marks
  occLogo: "/OCC Logo.png",
  occGamesLogo: "/Roslyn OCC Games Logo.png",
  occGamesLogoWhite: "/Roslyn OCC Games Logo White.png",
};

// Local storage keys
export const STORAGE_KEYS = {
  gameState: "clashconnections_gameState",
  gameStats: "clashconnections_gameStats",
  adminPuzzle: "clashconnections_adminPuzzle",
  hasSeenHowToPlay: "clashconnections_hasSeenHowToPlay",
};

// Share message template
export const SHARE_TEMPLATE = {
  title: "Clash Connections",
  getShareText: (puzzleNumber, emojiGrid, mistakes) => {
    const mistakesText = mistakes === 0 ? "Perfect!" : `${mistakes} mistake${mistakes !== 1 ? 's' : ''}`;
    return `Clash Connections #${puzzleNumber}\n${emojiGrid}\n${mistakesText}\nclashconnections.roslynocc.com`;
  },
};

// Admin settings
export const ADMIN = {
  route: "/occ-admin",
  password: "clash2024", // Simple password for demo - in production, use proper auth
};

// Links
export const LINKS = {
  privacy: "/privacy.html",
  occ: "https://roslynocc.com",
  github: "https://github.com",
};

// Credits
export const CREDITS = {
  developers: ["Jordan Feldstein", "Olivia Jacobson"],
  organization: "Roslyn OCC",
  year: new Date().getFullYear(),
};
